<template>
  <div class="inner-box">
    <el-form size="small">
      <div class="content-name">
        <h2 class="dp-ib">프로그램관리</h2>
        <el-form-item label-width="0px" style="float: right;" v-if="this.parentId != 0">
          <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="deleteRow">삭제</el-button>
          <el-button type="primary" icon="el-icon-document-add" @click="save('main')">{{this.$i18n.messages[this.$store.state.locale].save}}</el-button>
        </el-form-item>
      </div>
    </el-form>

    <div class="talbe-contain" style="display: flex">
      <div class="table-area" style="margin: 5px 50px 0 0; width: 25%;">
        <div class="table-b">
          <ag-grid-vue
              ref="gridTree"
              style="width: 100%; height: 80vh; min-height: 25px;"
              class="ag-theme-alpine"
              :enableRangeSelection="true"
              :headerHeight="0"
              :rowModelType="rowModelType"
              :treeData="true"
              :isServerSideGroup="isServerSideGroup"
              :isServerSideGroupOpenByDefault="isServerSideGroupOpenByDefault"
              :getServerSideGroupKey="getServerSideGroupKey"
              :autoGroupColumnDef="autoGroupColumnDef"
              :animateRows="true"
              :rowData="data"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :gridOptions="gridOptions"
              :suppressRowClickSelection="false"
              @grid-ready="onReadyTree"
              @cell-clicked="onCellClickedTree"
          />
        </div>
      </div>
      <div class="table-area" style="width: 75%;">
        <div class="table-name">
          <h3 class="ico_table_name">선택된 프로그램 정보</h3>
        </div>
        <div class="table-b">
          <ag-grid-vue
              ref="gridMain"
              style="width: 100%; height: 18vh; min-height: 25px;"
              class="ag-theme-alpine"
              :enableRangeSelection="true"
              :columnDefs="columnDefsMain"
              :defaultColDef="defaultColDefMain"
              :frameworkComponents="frameworkComponents"
              :rowData="mainData"
              :gridOptions="gridOptionsMain"
              :suppressRowClickSelection="false"
              @grid-ready="onReadyMain"
          />
        </div>
        <div class="table-area">
          <div class="table-b">
            <div class="table-header">
              <div class="table-name">
                <h3 class="ico_table_name">하위 프로그램 리스트</h3>
              </div>
              <el-form style="display: grid; float: right;" size="small">
                <el-form-item label-width="0px">
                  <el-button type="success" icon="el-icon-document-add" @click="addRowd">추가</el-button>
                  <el-button type="danger" icon="el-icon-delete" @click="deleteRowd">삭제</el-button>
                  <el-button type="primary" icon="el-icon-document-add" @click="save('sub')">{{this.$i18n.messages[this.$store.state.locale].save}}</el-button>
                </el-form-item>
              </el-form>
            </div>
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 48vh; min-height: 25px;"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadySub"
                @cell-clicked="onCellClicked"
            />
          </div>
        </div>
      </div>
    </div> <!-- table contain -->
  </div>


</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer';
import common from '@/mixin/common';
import ProgramInfo from '@/components/InfoManage/ProgramInfo.vue';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "program",
  components: {ProgramInfo},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      rowData: [],
      onReadyParams: [],
      parentNm: "",
      parentId: "0",
      form: {
        programKey: "",
        programNm: "",
        programId: "",
        parentId: "",
        topKey: "",
        programIdx: "",
        description: "",
      },
      defForm: {
        programKey: "",
        programNm: "",
        programId: "",
        parentId: "",
        topKey: "",
        programIdx: "",
        description: "",
      },
      data: [],
      mainData: [],
      subData: [],
      gridParams: {},
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsMain: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefMain: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        //width: 240,
        //flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        //width: 240,
        //flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      programDetail: [],
      gridApi: null,
      columnApi: null,
      gridApiMain: null,
      columnApiMain: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsMain: [],
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId: "",
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyTree(params) {
      //메인그리드 api 정의
      this.onReadyParams = params;
      this.gridParams = params;
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

      const updateData = (data) => {
        var fakeServer = this.createFakeServer(data);
        var datasource = this.createServerSideDatasource(fakeServer);
        params.api.setServerSideDatasource(datasource);
        return data;
      };
      this.$http.post(_url("/api/tree/program/list"), {
        companyId: this.$store.state.loginInfo.compCd,
      }).then(response => {
        this.data = updateData(response.data);
      });
    },
    onReadyMain(params) {
      this.gridApiMain = this.gridOptionsMain.api;
      this.columnApiMain = this.gridOptionsMain.columnApi;
      this.gridApiMain.sizeColumnsToFit();
      // this.gridApiMain.autoSizeAllColumns();
      this.autoSizeAll(this.columnApiMain);
    },
    onMainTree() {
      const updateData = (data) => {
        var fakeServer = this.createFakeServer(data);
        var datasource = this.createServerSideDatasource(fakeServer);
        this.gridParams.api.setServerSideDatasource(datasource);
        return data;
      };
      this.$http.post(_url("/api/tree/program/list"), {
        companyId: this.$store.state.loginInfo.compCd,
      }).then(response => {
        this.data = updateData(response.data);
      });
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      this.gridApiSub.sizeColumnsToFit();
      // this.gridApiSub.autoSizeAllColumns();
      this.autoSizeAll(this.columnApiSub);
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indiprograme if node is a group
        //console.log(dataItem);
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsMain = [
        {headerName: 'ID', field: 'parentId', headerClass: 'require-column', width: 150, editable: false},
        {headerName: '프로그램명', field: 'programNm', headerClass: 'require-column', width: 150, editable: true},
        {headerName: '메뉴명', field: 'menuNm', headerClass: 'require-column', width: 150, editable: true},
        {headerName: 'url', field: 'url', width: 150, editable: true},
        {headerName: '파라미터', field: 'parameter', width: 150, editable: true},
        {headerName: 'url형식', field: 'navigateuUrl', width: 150, editable: true},
        {
          headerName: '메뉴'
          , field: 'menuYn'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '등록'
          , field: 'programInsert'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '수정'
          , field: 'programUpdate'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '삭제'
          , field: 'programDelete'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '인쇄'
          , field: 'programPrint'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {headerName: '확장권한1', field: 'programExtend1', width: 50, editable: true},
        {headerName: '확장권한2', field: 'programExtend2', width: 50, editable: true},
        {headerName: '확장권한3', field: 'programExtend3', width: 50, editable: true},
        {headerName: '확장권한4', field: 'programExtend4', width: 50, editable: true},
        {headerName: '확장권한5', field: 'programExtend5', width: 50, editable: true},
        {headerName: '확장권한6', field: 'programExtend6', width: 50, editable: true},
        {headerName: '확장권한7', field: 'programExtend7', width: 50, editable: true},
        {headerName: '확장권한8', field: 'programExtend8', width: 50, editable: true},
        {headerName: '확장권한9', field: 'programExtend9', width: 50, editable: true},
        {headerName: '비고', field: 'description', width: 150, editable: true},
      ];

      this.columnDefsSub = [
        {
          headerName: '선택'
          , field: 'regYn'
          , width: 50
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "1"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "0"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {headerName: '순서', field: 'programIdx', headerClass: 'require-column', width: 200, editable: true},
        {headerName: '프로그램명', field: 'programNm', headerClass: 'require-column', width: 150, editable: true},
        {headerName: '메뉴명', field: 'menuNm', headerClass: 'require-column', width: 150, editable: true},
        {headerName: 'url', field: 'url', width: 150, editable: true},
        {headerName: '파라미터', field: 'parameter', width: 150, editable: true},
        {headerName: 'url형식', field: 'navigateuUrl', width: 150, editable: true},
        {
          headerName: '메뉴'
          , field: 'menuYn'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '등록'
          , field: 'programInsert'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '수정'
          , field: 'programUpdate'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '삭제'
          , field: 'programDelete'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Yㄹ", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {
          headerName: '인쇄'
          , field: 'programPrint'
          , width: 150
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {headerName: '확장권한1', field: 'programExtend1', width: 50, editable: true},
        {headerName: '확장권한2', field: 'programExtend2', width: 50, editable: true},
        {headerName: '확장권한3', field: 'programExtend3', width: 50, editable: true},
        {headerName: '확장권한4', field: 'programExtend4', width: 50, editable: true},
        {headerName: '확장권한5', field: 'programExtend5', width: 50, editable: true},
        {headerName: '확장권한6', field: 'programExtend6', width: 50, editable: true},
        {headerName: '확장권한7', field: 'programExtend7', width: 50, editable: true},
        {headerName: '확장권한8', field: 'programExtend8', width: 50, editable: true},
        {headerName: '확장권한9', field: 'programExtend9', width: 50, editable: true},
        {headerName: '비고', field: 'description', width: 150, editable: true},
        {headerName: '', field: 'programId', hide: true}
      ];
    },
    //Tree 그리드 SelctionChange 발생
    onCellClickedTree(params) {
      const voRow = params.data; //선택된 Row
      this.rowData = params.data;
      this.programDetail = this.defForm;
      this.parentNm = voRow.menu_nm;
      this.parentId = voRow.menu_id;
      this.$store.commit('loading')

      //
      this.$http
          .post("/api/program/detail/sub", {
            companyId: this.$store.state.loginInfo.compCd,
            programId: this.parentId,
            processTime: ""
          })
          .then(response => {
            if (response.data[0]) {
              this.mainData = response.data;
            }

            if (voRow.menu_id == 0) {
              this.mainData = [];
            }

          }).finally(() => {
        this.autoSizeAll(this.gridApiMain);
      });

      //
      this.$http
          .post("/api/program/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            parentId: voRow.menu_id,
            sortType: true,
            page: 1,
            totalPage: 9999,
            totalCount: 9999,
            curPage: 0,
            processTime: ""
          })
          .then(response => {
            this.subData = response.data
            this.selectId = voRow.menu_id;
          }).finally(() => {
        this.autoSizeAll(this.gridApiSub);
        this.$store.commit('finish')
      });
    },
    goOpen() {

      // detail 재실행
      this.$store.commit('loading')
      this.$http
          .post("/api/program/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            parentId: this.selectId,
            sortType: true,
            page: 1,
            totalPage: 9999,
            totalCount: 9999,
            curPage: 0,
            processTime: ""
          })
          .then(response => {
            this.subData = response.data
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    save(type) {

        let programInfo;
        if (type == 'main') {
          programInfo = this.mainData;
        } else {
          programInfo = this.subData;
        }

        if (!this.gridRequireCheck([this.$refs.gridTree, this.$refs.gridSub])) return;

          let submitList = [];

          programInfo.forEach(x => {
            submitList.push({
              parentId: this.selectId,
              programIdx: x.programIdx,
              programNm: x.programNm,
              menuNm: x.menuNm,
              url: x.url,
              parameter: x.parameter,
              navigateuUrl: x.navigateuUrl,
              programInsert: x.programInsert,
              programUpdate: x.programUpdate,
              programDelete: x.programDelete,
              programPrint: x.programPrint,
              programExtend1: x.programExtend1,
              programExtend2: x.programExtend2,
              programExtend3: x.programExtend3,
              programExtend4: x.programExtend4,
              programExtend5: x.programExtend5,
              programExtend6: x.programExtend6,
              programExtend7: x.programExtend7,
              programExtend8: x.programExtend8,
              programExtend9: x.programExtend9,
              menuYn: x.menuYn,
              useYn: x.useYn,
              description: x.description,
              programId: this.isEmpty(x.programId) == "" ? 0 : x.programId,
            });
          });

          this.$store.commit('loading')
          this.$http
          .put('/api/program/save', submitList)
          .then(response => {
            this.$swal({type: 'success', text: '저장되었습니다.'});
            this.onReadyTree(this.onReadyParams);
            this.goOpen();
          })
          .catch(({message}) => {
            if (message === "Request failed with status code 500") {
              this.$swal({type: "error", text: "오류가 발생했습니다."});
            }
          }).finally(() => {
            this.$store.commit('finish');
          });



    },
    saveIdx() {

      let subData = this.$refs.gridSub.rowData;
      try {
        for (var i = 0; subData.length; i++) {
          this.$http
              .put('/api/program/update/idx', {
                companyId: this.$store.state.loginInfo.compCd,
                programId: subData[i].programId,
                programIdx: subData[i].programIdx,
                updatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
                processTime: ""
              })
              .then(response => {

              })
              .catch(({message}) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({type: "error", text: "오류가 발생했습니다."});
                }
              });
        }
      } catch (e) {
        this.$swal({
          type: 'error',
          text: '오류가 발생했습니다.'
        })
      }
      this.$swal({type: 'success', text: '수정되었습니다.'});
      this.goOpen();

    },
    //그리드 Cell 클릭 함수
    onCellClicked(event) {
      const idx = event.rowIndex;
      const field = event.colDef.field;
      const programId = event.data.programId;
    },

    deleteRow() {

      const grid = this.$refs.gridMain.rowData

      const programId = grid[0].programId;

      this.$swal({
        type: 'info',
        text: `선택한 프로그램을 삭제하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$store.commit('loading')
          this.$http.delete(_url('/api/program/delete/' + this.$store.state.loginInfo.compCd  +'/'  + programId + '/' +this.$store.state.loginInfo.id ),
              {
                process_time: ""
              }).then(response => {
            if (response.data) {
              this.$swal({type: 'info', text: '삭제 완료 하였습니다.'});
            }
            this.mainData = [];
            this.subData = [];
            this.onMainTree();
          })
              .catch(({message}) => {
                console.error(message);
              }).finally(() => {
            this.$store.commit('finish')
          })
        }
      })

    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    addRow() {
      this.data.push({
        compCd: this.$store.state.loginInfo.compCd,
      });
    },
    deleteRowd() {

      try {

        const grid = this.$refs.gridSub

        const chkDatas = grid.rowData.filter((x,i) => {
          return x.regYn === "1"
        })

        if(chkDatas.length == 0)this.$swal({ type: 'error', text: '삭제할 분류를 체크하세요.' });


        this.$swal({
          type: 'info',
          text: `선택한 프로그램을 삭제하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        }).then((result) => {

          if(result){

            let submitList = [];

            chkDatas.forEach(x => {
              if(this.isEmpty(x.programId) != ""){
                submitList.push({
                  programId: this.isEmpty(x.programId) == "" ? 0 : x.programId,
                });
              }
            });

            this.$store.commit('loading')
            this.$http
                .put('/api/program/delete', submitList)
                .then(response => {
                  this.$swal({type: 'success', text: '삭제되었습니다.'});
                  this.onReadyTree(this.onReadyParams);
                  this.goOpen();
                })
                .catch(({message}) => {
                  if (message === "Request failed with status code 500") {
                    this.$swal({type: "error", text: "오류가 발생했습니다."});
                  }
                }).finally(() => {
              this.$store.commit('finish');
            });
          }

        }).catch(({message}) => {
          if (message === "Request failed with status code 500") {
            this.$swal({type: "error", text: "오류가 발생했습니다."});
          }
        });

      } catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    addRowd() {
      try {

        const row = this.rowData;

        if (row.length < 1)
          throw '그룹코드가 선택되지 않았습니다.'

        const idx = row.rowIndex
        let maxIdx = 0;

        for (var i = 0; this.subData.length > i ; i++){
          if(this.subData[i].programIdx > maxIdx) maxIdx = this.subData[i].programIdx;
        }

        this.subData.push({
          companyId : this.$store.state.loginInfo.compCd,
          createDt : "",
          creatorId  : this.$store.state.loginInfo.id,
          deleteYn : "",
          description : "",
          menuNm : "",
          menuYn : "",
          navigateuUrl : "",
          no : "",
          parameter : "",
          parentId : "",
          programDelete : "",
          programExtend1 : "",
          programExtend2 : "",
          programExtend3 : "",
          programExtend4 : "",
          programExtend5 : "",
          programExtend6 : "",
          programExtend7 : "",
          programExtend8 : "",
          programExtend9 : "",
          programId : 0,
          programIdx : maxIdx+1,
          programInsert : "",
          programLvl : "",
          programNm : "",
          programPath : "",
          programPrint : "",
          programUpdate : "",
          sortPath : "",
          updateDt : "",
          updatorId : "",
          url : "",
          useYn : "Y",
        });
      } catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    cancel() {
      // programInfo 초기화
      this.goOpen();
    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(groupKeys, data) {
            if (groupKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0 ? false : true;
                return {
                  group: has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                };
              });
            }
            var key = groupKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                    groupKeys.slice(1),
                    data[i].inner_menu.slice()
                );
              }
            }
          }

          return extractRowsFromData(request.groupKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {
          //console.log('ServerSideDatasource.getRows: params = ', params);

          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
              ? {
                rowData: allRows.slice(request.startRow, request.endRow),
                rowCount: allRows.length,
              }
              : {rowData: allRows};
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
      buttonCellRenderer: ButtonCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
}
</script>